// to do: remove adv, acc, pub, website, from table search ;
import React, { Component } from 'react';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import Select from 'react-select';
import { Admin as Layout } from '../../../components/layouts';
import { Spinner, DateRange } from '../../../components/common';
import { AdminApi } from '../../../api';
import { humanize } from '../../../utils/helpers/text_formatters';
import ExportCSVButton from '../../../components/common/ExportCSVButton';
import { StatBar } from '../../../components/common';

import { currencyFields } from '../../../utils/constants';
import { currencyFormat } from '../../../utils/helpers/currency';
import { numberFormat, averagePercentFormat } from '../../../utils/helpers/number_formatter';
import { calendarRanges } from '../../../utils/helpers/calendar_ranges';

class AdminConnectionReportsIndex extends Component {
  componentWillMount() {
    const filters = this.getDropdownFilters({});
    this.fetchResource({ filters });
  }

  getDropdownFilters(selectedValue) {
    const { selectedCountryCode, selectedCampaign, selectedWebsite, selectedStartDate, selectedEndDate } = this.props;
    const filters = {
      start_date: { value: selectedStartDate },
      end_date: { value: selectedEndDate },
      country_code: { value: selectedCountryCode },
      campaign_id: { value: selectedCampaign },
      website_id: { value: selectedWebsite },
      ...selectedValue,
    };

    return filters;
  }

  fetchResource(params = {}) {
    const { resourceName, dispatch } = this.props;
    const countryCode = get(params, 'filters.country_code.value', 'US');

    dispatch(AdminApi.actions[resourceName](params));
    dispatch(AdminApi.actions.connectionReportStats(params));
    dispatch(AdminApi.actions.connectionReportFeeds({ country_code: countryCode }));
  }

  handleOnPageChange(page, per_page) {
    this.fetchResource({
      page,
      per_page,
      filters: get(this.props, 'resource.meta.filters', {}),
      sort: get(this.props, 'resource.meta.sort', {}),
    });
  }

  columnWidth(field) {
    switch (field) {
      case 'website':
      case 'campaign':
      case 'excluded_conversions':
      case 'total_conversions':
      case 'fraud_percent':
      case 'sandbox_percent':
      case 'expired_percent':
      case 'foreign_percent':
      case 'duplicate_percent':
      case 'over_budget_percent':
      case 'latent_percent':
      case 'over_budget_clicks':
        return '180';
      case 'duplicate_amount':
      case 'expired_amount':
      case 'excluded_amount':
      case 'billable_earned':
      case 'billable_spend':
        return '160';
      case 'country_code':
      case 'total_clicks':
      case 'fraud_clicks':
      case 'expired_clicks':
      case 'excluded_clicks':
      case 'duplicate_clicks':
      case 'latent_clicks':
      case 'sandbox_clicks':
      case 'foreign_clicks':
      case 'fraud_amount':
        return '140';
      case 'conversions':
        return '120';
      case 'aepc':
      case 'acpc':
      case 'aepa':
      case 'acpa':
      case 'earned':
      case 'spend':
      case 'clicks':
        return '80';
      default:
        return '100';
    }
  }

  handleDateApply(d) {
    let filters = {};

    filters = this.getDropdownFilters({ start_date: { value: d.startDate.format() }, end_date: { value: d.endDate.format() } });

    this.fetchResource({
      filters,
      sort: get(this.props, 'resource.meta.sort', {}),
    });
  }

  handleOnSortChange(field, order) {
    const sort = { field, order };

    this.fetchResource({
      filters: get(this.props, 'resource.meta.filters', {}),
      sort,
    });
  }

  handleCampaignChange(campaignIds) {
    let filters = {};

    if (campaignIds?.length > 0) {
      filters = this.getDropdownFilters({ campaign_id: { value: campaignIds } });
    } else {
      filters = this.getDropdownFilters({ campaign_id: { value: [] } });
    }

    this.fetchResource({
      filters,
      sort: get(this.props, 'resource.meta.sort', {}),
    });
  }

  handleWebsiteChange(websiteIds) {
    let filters = {};

    if (websiteIds?.length > 0) {
      filters = this.getDropdownFilters({ website_id: { value: websiteIds } });
    } else {
      filters = this.getDropdownFilters({ website_id: { value: [] } });
    }

    this.fetchResource({
      filters,
      sort: get(this.props, 'resource.meta.sort', {}),
    });
  }

  handleCountryCodeChange(countryCode) {
    let filters = {};

    if (countryCode) {
      filters = this.getDropdownFilters({
        country_code: { value: countryCode?.value || 'US' },
        website_id: { value: [] },
        campaign_id: { value: [] },
      });
    } else {
      filters = this.getDropdownFilters({ country_code: { value: 'US' } });
    }

    this.fetchResource({
      filters,
      sort: get(this.props, 'resource.meta.sort', {}),
    });
  }

  formatData(field, columnAttributes, value) {
    switch (columnAttributes[field]) {
      case 'datetime':
        return value ? moment(value).utc().format('MMMM Do[,] YYYY') : value;
      case 'integer':
      case 'float':
      case 'decimal':
        return currencyFields.includes(field) ? currencyFormat(value) : numberFormat(value);
      default: {
        return value;
      }
    }
  }

  render() {
    const {
      resourceName,
      resource,
      isLoading,
      grossStats,
      campaignOptions,
      websiteOptions,
      selectedCampaign,
      selectedWebsite,
      selectedStartDate,
      selectedEndDate,
      selectedCountryCode,
      columnAttributes,
    } = this.props;
    const { data, meta } = resource || {};
    const { filters } = meta || {};
    const { pagination, column_info, sort } = meta || {};
    const index = get(column_info, 'index_page', []);
    const valueStyles = { fontSize: '14px' };
    const boxStyles = { height: '100px' };

    if (index.length > 1) index.move(index.indexOf('id'), 0);

    const CSVButton = () => {
      return <ExportCSVButton resourceName={resourceName} filters={filters} start_date={selectedStartDate} end_date={selectedEndDate} />;
    };

    const options = {
      exportCSVBtn: CSVButton,
      onSortChange: this.handleOnSortChange.bind(this),
      sortName: get(sort, 'field', 'id'),
      sortOrder: get(sort, 'order', 'desc'),
      defaultSortName: get(sort, 'field', 'ctr'),
      defaultSortOrder: get(sort, 'order', 'desc'),
      sizePerPage: get(pagination, 'per_page', 10),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1),
    };

    const fetchInfo = {
      dataTotalSize: get(pagination, 'total_count', 0),
    };

    const passProps = pick(this.props, ['routeParams', 'location', 'routes']);
    const countryCodeOptions = [
      { value: 'US', label: 'US' },
      { value: 'CA', label: 'CA' },
    ];

    return (
      <Layout {...passProps}>
        <div className="ibox">
          <div className="ibox-title">
            <h5>{humanize(resourceName)}</h5>
          </div>
          <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Row className="connection-reports-date-range">
              <Col md={12}>
                <div className="pull-left date-padding">
                  <DateRange
                    key="daterange-ad-cu-dash"
                    defaultChosenLabel="This Month"
                    opens="right"
                    startDate={moment(selectedStartDate)}
                    endDate={moment(selectedEndDate)}
                    ranges={calendarRanges}
                    onApply={this.handleDateApply.bind(this)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Select
                  value={selectedCountryCode}
                  options={countryCodeOptions}
                  placeholder="Filter country"
                  onChange={this.handleCountryCodeChange.bind(this)}
                  className="reports-dropdown"
                  clearable={false}
                />
              </Col>
              <Col md={4}>
                <Select
                  value={selectedCampaign}
                  onChange={this.handleCampaignChange.bind(this)}
                  options={campaignOptions}
                  placeholder="Filter campaign"
                  className="reports-dropdown"
                  multi
                />
              </Col>
              <Col md={4}>
                <Select
                  value={selectedWebsite}
                  onChange={this.handleWebsiteChange.bind(this)}
                  options={websiteOptions}
                  placeholder="Filter website"
                  className="reports-dropdown"
                  multi
                />
              </Col>
            </Row>
            <br />
            <Row>
              <div>
                <StatBar
                  label="Billable Spend"
                  column="col-md-2"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={currencyFormat(grossStats?.gross_billable_spend || 0.0)}
                />
                <StatBar
                  label="Billable Earned"
                  column="col-md-2"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={currencyFormat(grossStats?.gross_billable_earned || 0.0)}
                />
                <StatBar
                  label="Clicks"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={numberFormat(grossStats?.gross_clicks || 0)}
                />
                <StatBar
                  label="Conversions"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={numberFormat(grossStats?.gross_conversions || 0)}
                />
                <StatBar
                  label="Fraud Clicks"
                  column="col-md-2"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={numberFormat(grossStats?.gross_fraud_clicks || 0.0)}
                />
                <StatBar
                  label="Expired Clicks"
                  column="col-md-2"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={numberFormat(grossStats?.gross_expired_clicks || 0.0)}
                />
                <StatBar
                  label="Latent Clicks"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={numberFormat(grossStats?.gross_latent_clicks || 0)}
                />
                <StatBar
                  label="Duplicate Clicks"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={numberFormat(grossStats?.gross_duplicate_clicks || 0)}
                />
                <StatBar
                  label="ACPC"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={averagePercentFormat(grossStats?.gross_acpc || 0)}
                />
                <StatBar
                  label="AEPC"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={averagePercentFormat(grossStats?.gross_aepc || 0)}
                />
                <StatBar
                  label="ACPA"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={averagePercentFormat(grossStats?.gross_acpa || 0)}
                />
                <StatBar
                  label="AEPA"
                  column="col-lg-2 col-md-6 col-sm-6"
                  valueStyles={valueStyles}
                  boxStyles={boxStyles}
                  value={averagePercentFormat(grossStats?.gross_aepa || 0)}
                />
              </div>
            </Row>
            <Spinner />
            <BootstrapTable
              exportCSV
              striped
              ref={c => {
                this.table = c;
              }}
              data={data || []}
              remote
              pagination
              fetchInfo={fetchInfo}
              options={options}
            >
              {index.length > 1 ? (
                index.map((field, i) => {
                  const isResourceKey = field === 'id';
                  return (
                    <TableHeaderColumn
                      key={`${resourceName}-column-${i}`}
                      isKey={isResourceKey}
                      width={this.columnWidth(field)}
                      dataSort={!isResourceKey}
                      dataField={field}
                      dataFormat={this.formatData.bind(this, field, columnAttributes)}
                      tdStyle={{ whiteSpace: 'normal' }}
                      thStyle={{ whiteSpace: 'normal' }}
                      hidden={isResourceKey}
                    >
                      {field}
                    </TableHeaderColumn>
                  );
                })
              ) : (
                <TableHeaderColumn isKey dataField={resourceName} />
              )}
            </BootstrapTable>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const resourceName = 'connectionReports';
  const resource = state.admin[resourceName];
  const grossStats = get(state.admin.connectionReportStats, 'data.stats', {});

  const columnAttributes = get(resource, 'data.meta.column_info.attributes', {});
  const selectedCountryCode = get(resource, 'data.meta.filters.country_code.value', 'US');
  const selectedCampaign = get(resource, 'data.meta.filters.campaign_id.value', []);
  const selectedWebsite = get(resource, 'data.meta.filters.website_id.value', []);
  const campaignOptions = get(state.admin.connectionReportFeeds.data, 'campaign_dropdown', [])?.map(arr => ({
    value: arr[0],
    label: arr[1],
  }));
  const websiteOptions = get(state.admin.connectionReportFeeds.data, 'website_dropdown', [])?.map(arr => ({
    value: arr[0],
    label: arr[1],
  }));
  const metaStartDate = get(resource, 'data.meta.filters.start_date.value', null);
  const metaEndDate = get(resource, 'data.meta.filters.end_date.value', null);
  const selectedStartDate = metaStartDate ? moment(metaStartDate).format() : moment().startOf('month').format();
  const selectedEndDate = metaEndDate ? moment(metaEndDate).format() : moment().format();

  return {
    resourceName,
    resource: resource.data,
    isLoading: resource.loading,
    selectedStartDate,
    selectedEndDate,
    columnAttributes,
    selectedCountryCode,
    campaignOptions,
    websiteOptions,
    selectedCampaign,
    selectedWebsite,
    grossStats,
  };
};
export default connect(mapStateToProps)(AdminConnectionReportsIndex);
